// views
import { Row, Col } from "antd";
import UserTag from "~/components/user/UserTag";
import UserAvatar from "~/components/user/UserAvatar";
import UserLevel from "~/components/users/UserLevel";
import UserAvatarEditor from "~/components/user/UserAvatarEditor";
import UserBind from "~/components/user/UserBind";
import settings from "~/settings";
import { hasAnyRole } from "../../utils/user";
import moment from "moment";

export default (props) => {
  const { user } = props;
  const isContributor = hasAnyRole(props.user, ["contributor"]);
  const isProhibitor = hasAnyRole(props.user, ["prohibitor"]);

  const renderTag = (tag) => <UserTag key={tag.id} tag={tag} />;

  return (
    <div className={`user-info-block${props.small ? " small" : ""}`}>
      {user && (
        <Row type="flex" align="middle">
          <Col style={{ flex: "0 0 80px" }}>
            {props.profile ? (
              <UserAvatarEditor />
            ) : (
              <UserAvatar user={user} size={60} />
            )}
          </Col>
          <Col style={{ flex: 1 }}>
            <Row type="flex" justify="space-between" align="middle">
              <Col className="body">
                <div className="user-info-box">
                  <h3>
                    {user.nickname}
                    {isProhibitor ? " [已封禁]" : ""}
                  </h3>
                  {isContributor && (
                    <div style={{ marginLeft: "12px", color: "#2dbaab" }}>
                      社区共建者
                    </div>
                  )}
                  {props.showLevel && <UserLevel level={user.level_info} />}
                  {props.profile && <UserBind />}
                </div>

                {user.tagline && <p>{user.tagline}&nbsp;</p>}

                {!props.small && (
                  <div className="mb-5">
                    {user.tags && user.tags.map(renderTag)}
                  </div>
                )}
                {props.showCreateTime && (
                  <div className="text-secondary font-14 px-5">
                    创建于{moment(user.created_at).format("YYYY年MM月DD日")}
                  </div>
                )}
              </Col>
              {props.extra}
            </Row>
          </Col>
        </Row>
      )}
    </div>
  );
};
